import { useState, useEffect, forwardRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import PropTypes from 'prop-types';
import styledComponents from "styled-components";
import Countdown from 'react-countdown';

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: '70%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const Completionist = () => <Button variant="outlined" disabled>APPROVE</Button>;

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist />;
  } else {
    // Render a countdown
  return <span style={{ color: 'blue', fontWeight: 'bolder', fontSize: '11px' }}>{days} h : {hours} j : {minutes} m : {seconds} d</span>;
  }
};

const PoDetail = ({
    poData,
    poForm,
    stokInfo,
    withStok,
    updatedWithStok,
    updatedStokInfo,
    updatedPoForm,
    page,
    pageInfo,
    pageSize,
    poSubdb,
    updatedPoSubdb,
    updatedPage,
    updatedPageInfo,
    updatedPageSize,
    openPo
}) => {
    const [openingModalPo, setOpeningModalPo] = useState(false);
    const [openModalPo, setOpenModalPo] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [tmpIdproduk, setTmpIdproduk] = useState(null);
    const [valToSubmit, setValToSubmit] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const navigate = useNavigate();

    const handleOpenModalPo = (idpoproduk) => {
      setOpenModalPo(true);
      setTmpIdproduk(idpoproduk);
    };

    const handleCloseModalPo = () => {
      setOpenModalPo(false);
      setOpeningModalPo(false);
      setSubmitting(false);
      setValToSubmit({});
    };

    const handleValToSubmit = (e, el) => {
      setOpeningModalPo(true);
      const val = {};
      val.value = parseInt(e.target.value); // jumlah baru
      val.stokUpdate = el.jumlah - parseInt(e.target.value)
      val.total = parseInt(e.target.value) * el.harga; // jumlah baru dikali harga satuan
      val.idMitra = el.idmitra;
      val.idpo = el.idpo;
      val.idpoproduk = el.idpoproduk;
      val.idpodetail = el.idpodetail;
      setValToSubmit({
          ...valToSubmit,
          [`po_${el.idpomitra}`]: val
      });
    };

    const handleSubmitPo = (e) => {
      setSubmitting(true);
      e.preventDefault();
      
      let sumStok = 0;
      const errorStok = [];
      console.log(valToSubmit);
      if (withStok && stokInfo.length > 0) {
        stokInfo.forEach((item) => {
          let tmpAmount = 0;
          for (const [key, value] of Object.entries(valToSubmit)) {
            if (item.idpo === valToSubmit[key].idpo ) {
                tmpAmount += valToSubmit[key].value;
                if (valToSubmit[key].stokUpdate + item.stok < 0) {
                  errorStok.push(
                    {
                        idpo: item.idpo,
                        message: `Order ${item.namakategori} melebihi stok`
                    }
                  );
                }
            }
            sumStok += valToSubmit[key].stokUpdate;
          }
        });
      }

      if( Object.keys(valToSubmit).length === 0 || (withStok && sumStok === 0)) {
        setOpenAlert(true);
        setAlertStatus('warning');
        setAlertMessage('Tidak ada perubahan !');
        setSubmitting(false);
      } else if (errorStok.length > 0 && withStok) {
        setOpenAlert(true);
        setAlertStatus('error');
        setAlertMessage('Terdapat order melebihi stok !');
        setSubmitting(false);
      } else {
        const auth = async () => {
          try {
              let idMitra = null;
              const me = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`,
                {
                  headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  }
                }
              );
              if (me.data.result.role === 'distributor') {
                idMitra = me.data.result.admin_mitra.idadmin
              }
              if (me.data.result.role === 'agen') {
                idMitra = me.data.result.mitra_agen.idmitraagen
              }
              if (me.data.result.role === 'reseller') {
                idMitra = me.data.result.mitra_reseller.idmitrareseller
              }
              if (me.data.result.role === 'marketer') {
                idMitra = me.data.result.mitra_marketer.idmitramarketer
              }

              for (const [key, value] of Object.entries(valToSubmit)) {
                valToSubmit[key].idMitra = idMitra
              }
              await submitPo();
          } catch (err) {
            console.log(err);
            setOpenModalPo(false);
            setOpeningModalPo(false);
            setSubmitting(false);
            setValToSubmit({});
          }
        };
        const submitPo = async () => {
          const data = {
            stok: withStok,
            data: valToSubmit
          };
          try {
              await axios.put(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/update/${poData.idpoproduk}`,
                data,
                {
                  headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  }
                }
              );
              await getFormPo(poData.idpoproduk, poData.invoice);
              handleCloseModalPo();
              setOpenAlert(true);
              setAlertStatus('success');
              setAlertMessage('Stok telah diubah !');
          } catch (err) {
            console.log(err);
            setOpenModalPo(false);
            setOpeningModalPo(false);
            setSubmitting(false);
            setValToSubmit({});
          }
        };
        const getFormPo = async (idpoproduk, invoice) => {
          try {
              const poform = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/update/${idpoproduk}`, {
                  headers: {
                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                  },
                  params: {
                      idpoproduk,
                      invoice
                  }
              });

              let arrStok = [];

              if (poform.data.result.jenis_po === "PO dengan Stok") {
                updatedWithStok(true);
                  const mappedStok = poform.data.result.form.map((e) => {
                      return { idpo: e.idpo, namakategori: e.namakategori, stok: e.stok }
                  })
                  arrStok = mappedStok.filter((value, index, self) =>
                      index === self.findIndex((t) => (
                          t.idpo === value.idpo
                      ))
                  );
              }
              await updatedStokInfo(arrStok);
              await updatedPoForm(poform.data.result);

          } catch (err) {
              console.log(err);
          }
        };
        auth();
      }
    };

    const handleCloseAlert = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }
      setOpenAlert(false);
    };

    const handlePage = (event, value) => {
      updatedPage({ value });
      const serviceToken = window.localStorage.getItem('serviceToken');
      const getData = async () => {
          try {
            const po = await axios.get(
              `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/subdb`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                },
                params: {
                    idpoproduk: poData.idpoproduk,
                    page: value,
                    perPage: pageSize.value
                }
            });

            updatedPoSubdb(po.data.result.data);

            const pageInfoRes = Object.keys(products.data.result)
                .filter((key) => {
                    if (key !== 'data') return true;
                    return false;
                })
                .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
            updatedPageInfo(pageInfoRes);

          } catch (err) {
              console.log(err);
          }
      };
      getData();
    };

    const handleAppSubDb = async (invoice) => {
      try {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/pomitra/approve/${invoice}`, [], {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
        });

        const po = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/subdb`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
            params: {
                idpoproduk: poData.idpoproduk,
                page: 1,
                perPage: pageSize.value
            }
        });

        updatedPoSubdb(po.data.result.data);
        const pageInfoRes = Object.keys(po.data.result)
            .filter((key) => {
                if (key !== 'data') return true;
                return false;
            })
            .reduce((cur, key) => Object.assign(cur, { [key]: po.data.result[key] }), {});
        updatedPageInfo(pageInfoRes);

      } catch (err) {
          console.log(err);
      }
    };

    const handleCancelSubDb = async (invoice) => {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/pomitra/${invoice}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
        });

        const po = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/subdb`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
            params: {
                idpoproduk: poData.idpoproduk,
                page: 1,
                perPage: pageSize.value
            }
        });

        updatedPoSubdb(po.data.result.data);
        const pageInfoRes = Object.keys(po.data.result)
            .filter((key) => {
                if (key !== 'data') return true;
                return false;
            })
            .reduce((cur, key) => Object.assign(cur, { [key]: po.data.result[key] }), {});
        updatedPageInfo(pageInfoRes);

      } catch (err) {
          console.log(err);
      }
    };

    return (
      <Container>
        <Snackbar
            open={openAlert}
            autoHideDuration={2500}
            onClose={handleCloseAlert}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            key={'top' + 'center'}
        >
            <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                {alertMessage}
            </Alert>
        </Snackbar>

        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ margin: '10px 14px'}}>
            <Typography variant="subtitle1" fontWeight="700">Detail PO {poData?.namapo}</Typography>
          </Grid>
          <Grid item xs={12} sx={{ paddingY: '22px' }}>
            <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
              <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 540 }}>
                <TableHead>
                    <TableRow>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Tanggal</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Status</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Invoice</Typography></TableCell>
                        {new Date(openPo.tgl_dropship) >= new Date() && (
                          <TableCell><Typography variant="subtitle2" fontWeight="700">List Dropship</Typography></TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell><Typography variant="subtitle2">{poData?.tgl}</Typography></TableCell>
                    <TableCell><Typography variant="subtitle2">{poData?.status}</Typography></TableCell>
                    <TableCell>
                      <Typography variant="subtitle2">
                        <Link to={`/dashboard/po/invoice/${poData?.invoice}/${poData?.idpoproduk}`}>
                          {poData?.invoice}
                        </Link>
                      </Typography>
                    </TableCell>
                    {new Date(openPo.tgl_dropship) >= new Date() && (
                      <TableCell>
                        <Link to={`/dashboard/po/dropship?invoice=${poData.invoice}&idpoproduk=${poData.idpoproduk}`}>
                          <Typography variant="subtitle1">Lihat dropship</Typography>
                        </Link>
                      </TableCell>
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} sx={{ margin: '10px 14px'}}>
            <Typography variant="subtitle1" fontWeight="700">PO mitra Sub DB</Typography>
          </Grid>
          <Grid item xs={12} sx={{ paddingY: '22px' }}>
            <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
              <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 540 }}>
                <TableHead>
                    <TableRow>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Tanggal</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Nama PO</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Nama Mitra</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Status Mitra</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Status</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Invoice</Typography></TableCell>
                        <TableCell><Typography variant="subtitle2" fontWeight="700">Approve</Typography></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {poSubdb.map((row) => (
                    <TableRow>
                      <TableCell><Typography variant="subtitle2">{row?.tgl}</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2">{row?.namapo}</Typography></TableCell>
                      <TableCell><Typography variant="subtitle2">{row.agen}{row.reseller}{row.marketer}</Typography></TableCell>
                      <TableCell>
                        <Typography variant="subtitle2">
                          {row.agen !== null && `Agen`}
                          {row.reseller !== null && `Reseller`}
                          {row.marketer !== null && `Marketer`}
                        </Typography>
                      </TableCell>
                      <TableCell><Typography variant="subtitle2">{row.status}</Typography></TableCell>
                      <TableCell>
                        <Typography variant="subtitle2">
                          {row.idmitraagen !== null && (
                            <Link to={`/dashboard/po/subdb/invoice/${row.invoice}/${poData.idpoproduk}/${row.idmitraagen}`}>
                              {row.invoice}
                            </Link>
                          )}
                          {row.idmitrareseller !== null && (
                            <Link to={`/dashboard/po/subdb/invoice/${row.invoice}/${poData.idpoproduk}/${row.idmitrareseller}`}>
                              {row.invoice}
                            </Link>
                          )}
                          {row.idmitramarketer !== null && (
                            <Link to={`/dashboard/po/subdb/invoice/${row.invoice}/${poData.idpoproduk}/${row.idmitramarketer}`}>
                              {row.invoice}
                            </Link>
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell style={{ minWidth: '120px' }}>
                        <Stack spacing={2}>
                          {row.status == 'Belum Acc DB' && openPo !== null ? (
                            <>
                              {Date.parse(new Date().toISOString().split('T')[0]) < Date.parse(openPo.tgl_acc_db) && (
                                <Button variant="outlined" color="primary" onClick={() => handleAppSubDb(row.invoice)}>Approve</Button>
                              )}
                              <Button variant="outlined" color="error" onClick={() => handleCancelSubDb(row.invoice)}>cancel</Button>
                              <Countdown date={new Date(openPo.tgl_acc_db)} renderer={renderer} />
                            </>
                          ) : (
                            <Button variant="outlined" color="error" onClick={() => handleCancelSubDb(row.invoice)}>cancel</Button>
                          )}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2}>
              <Pagination
                count={pageInfo ? pageInfo.last_page : 10}
                color="primary"
                page={page.value}
                onChange={handlePage}
                variant="outlined" shape="rounded" />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    )
}

export default PoDetail
